import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';


import { MatDialog } from '@angular/material/dialog';

import { Constant } from 'src/app/constants/constant';
import { CurrencyConversionService } from 'src/app/services/currency-conversion.service';
import { CommonService } from 'src/app/services/common.service';
import { ProductService } from 'src/app/services/product.service';
import { UserService } from 'src/app/services/user.service';
import { CartService } from 'src/app/services/cart.service';
import { Router } from '@angular/router';
import { Product } from 'src/app/models/app.models';
import { SwiperConfigInterface } from 'src/app/theme/swiper/swiper.module';

@Component({
  selector: 'calsoft-product-carousel',
  templateUrl: './productcarousel.component.html',
  styleUrls: ['./productcarousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalsoftProductcarouselComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() categoryId: any;
  @Input() header: any;
  @Input() id: any;
  @Input() productImageHeight: any;
  @Input() showCartIcon: any;
  @Input() showCartIncremented: any;
  @Input() data: any;
  @Input() showConfigurableDropdown: any;
  @Input() urlNavigation: any = true;
  @Input() preloadCount: number = 2; // default number of slides to preload
  @Input() lowEnd: boolean = false;
  @Input() heightMobile: any;
  @Input() widthMobile: any;
  @Input() sortOrder: any;
  @Input() other: any;
  @Input() type: any = "home";
  @Input() height: any;
  @Input() width: any;
  @Input() imageType: any;
  @Input() item: any;
  @Input() slidesPerView: any;
  @Input() hideTitle: any = false;
  @Input() productLayoutType: any;
  categoryProducts: any;
  count: any;
  isEmpty: any;
  pageSize: any;
  public page: any = 0;
  size: number = 10;
  sortParam: any;
  @Input('products') products: Array<Product> = [];
  public config: SwiperConfigInterface = {};
  public showArrows: boolean = false;
  countryCode: string;
  url: string;
  // UI readiness flag to avoid showing partially-initialized carousel
  isReady: boolean = false;
  // whether we've kicked off lazy initialization (to avoid duplicate work)
  private hasInitialized: boolean = false;

  @ViewChild('carouselRoot', { static: false }) carouselRoot!: ElementRef;
  private intersectionObserver?: IntersectionObserver;
  // computed effective low-end flag (true if parent requested or auto-detected)
  effectiveLowEnd: boolean = false;

  categoryId5: any = 0;
  categoryId4: any = 0;
  customField27: any;
  customField28: any;
  customField29: any;
  @Input() border: any = 0;

  @Input() gap: any = 0;

  @Input() displayTitle: any = 0;
  mobileShow: number = 2;
  isDealOver: boolean = false;
  date: Date;
  showTimer: boolean;

  // public settings: Settings;
  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private currencyConversionService: CurrencyConversionService,
    private productService: ProductService,
    private userService: UserService,
    private cartServices: CartService,
    private router: Router
    , private cd: ChangeDetectorRef
  ) {

  }

  productLayoutEnable: any = 0;

  gapLayout: any = 0;


  ngOnInit(): void {

        // For mobile or low-end devices, reduce page size to avoid heavy initial loads
    try {
      const isMobile = (typeof window !== 'undefined') && window.innerWidth <= 768;
      if (isMobile || this.effectiveLowEnd) {
        this.size = 5;
      }
    } catch (e) {
      // ignore in non-browser environments
    }

    // Defensive: Ensure data exists and is an object
    if (this.data && typeof this.data === 'object') {
      if (window.innerWidth > 1279) {
        if (this.data.productWebGap != null && this.data.productWebGap !== '' && !isNaN(parseInt(this.data.productWebGap))) {
          this.gapLayout = parseInt(this.data.productWebGap.replace('px', ''));
        } else {
          this.gapLayout = 0;
        }
      } else if (window.innerWidth > 768 && window.innerWidth <= 1279) {
        if (this.data.tabWebGap != null && this.data.tabWebGap !== '' && !isNaN(parseInt(this.data.tabWebGap))) {
          this.gapLayout = parseInt(this.data.tabWebGap.replace('px', ''));
        } else {
          this.gapLayout = 0;
        }
      } else {
        if (this.data.productMobileGap != null && this.data.productMobileGap !== '' && !isNaN(parseInt(this.data.productMobileGap))) {
          this.gapLayout = parseInt(this.data.productMobileGap.replace('px', ''));
        } else {
          this.gapLayout = 0;
        }
      }
    } else {
      this.gapLayout = 0;
    }


    this.mobileShow = 2;
    this.slidesPerView = 4;
    if (this.item && typeof this.item === 'object') {
      if (this.item.customField30 !== undefined && this.item.customField30 !== null && this.item.customField30 > 0) {
        this.mobileShow = this.item.customField30;
      }
      if (this.item.customField29 !== undefined && this.item.customField29 !== null && this.item.customField29 > 0) {
        this.slidesPerView = this.item.customField29;
      }
    }



    this.url = this.router.url;

    if (this.type != 'product') {
      this.productsByCategory();
    } else {
      this.productsByList();
    }

    // Defensive: Ensure gapLayout, slidesPerView, mobileShow are always valid numbers
    if (isNaN(this.gapLayout) || this.gapLayout == null) this.gapLayout = 0;
    if (isNaN(this.slidesPerView) || this.slidesPerView == null) this.slidesPerView = 4;
    if (isNaN(this.mobileShow) || this.mobileShow == null) this.mobileShow = 2;

    if (this.productLayoutType == 17) {

      this.productLayoutEnable = 1

    } else {

      this.productLayoutEnable = 0;

    }


    if (this.item != null && typeof this.item === 'object') {
      if (this.categoryId4 != undefined && this.item.categoryId4 !== undefined) {
        this.categoryId4 = this.item.categoryId4;
      }

      if (this.categoryId5 != undefined && this.item.categoryId5 !== undefined) {
        this.categoryId5 = this.item.categoryId5;
      }

      if (this.item.customField27 != null && this.item.customField27 !== '') {
        try {
          document.documentElement.style.setProperty('--custom-width', this.item.customField27);
        } catch (e) {
          console.warn('Could not set --custom-width:', e);
        }
        this.customField27 = this.item.customField27;
      }

      if (this.item.customField28 != null && this.item.customField28 !== '') {
        try {
          document.documentElement.style.setProperty('--custom-width-mob', this.item.customField28);
        } catch (e) {
          console.warn('Could not set --custom-width-mob:', e);
        }
        this.customField28 = this.item.customField28;
      }

      if ((this.item?.customField31 !== undefined

        && this.item?.customField31 !== "") && this.item?.customField33 !== undefined

        && this.item?.customField33 !== "") {

        let utcDateStr = this.item?.customField31; // e.g., '2025-07-22T18:30:00.000Z'
        let timeStr = this.item?.customField33; // e.g., 'HH:mm'

        // Step 1: Convert UTC to IST string
        let istString = new Date(utcDateStr).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });

        // Step 2: Convert string back to Date object
        let istBaseDate = new Date(istString);

        // Step 3: Set time from customField33
        let hours = 0, minutes = 0;

        if (typeof timeStr === 'string' && timeStr.includes(':')) {
          [hours, minutes] = timeStr.split(':').map(Number);
        }
        istBaseDate.setHours(hours);
        istBaseDate.setMinutes(minutes);
        istBaseDate.setSeconds(0); // Optional: reset seconds


        const now = new Date();
        let nowIST = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        // Step 4: You now have final IST date with time


        let diffMillis = istBaseDate.getTime() - nowIST.getTime(); // Positive if future, negative if past

        // Convert to useful units
        let diffMinutes = Math.floor(diffMillis / (1000 * 60));
        let diffHours = Math.floor(diffMillis / (1000 * 60 * 60));
        let diffDays = Math.floor(diffMillis / (1000 * 60 * 60 * 24));
        let diffSeconds = Math.floor(diffMillis / 1000);


        if (isNaN(diffSeconds)) {

          diffSeconds = 0;
          this.isDealOver = true;

          this.showTimer = false;
        }


        if (diffSeconds) {
          this.countdownTarget = istBaseDate;
          this.date = istBaseDate;
          this.showTimer = true;
          this.startCountdown(); // start the timer
        }



      }
    } else {
      this.categoryId4 = this.border;
      this.categoryId5 = this.displayTitle;
    }

    let countryCode = this.currencyConversionService.getCountryCode();
    if (countryCode == null) {
      this.countryCode = "INR";
    }
    else {
      this.countryCode = countryCode;
    }

    // compute effective low-end: prefer explicit input, otherwise auto-detect
    this.effectiveLowEnd = !!this.lowEnd || this.isAutoDetectLowEnd();

    // if effectiveLowEnd is true, tune defaults conservatively so carousels
    // don't do heavy image preloads or show many slides on weak devices
    if (this.effectiveLowEnd) {
      this.preloadCount = Math.max(1, Math.floor(this.preloadCount / 2));
      this.slidesPerView = Math.min(this.slidesPerView || 3, 3);
      this.mobileShow = Math.min(this.mobileShow || 2, 2);
      try {
        // add a global class so global CSS can reduce animations/filters
        if (typeof document !== 'undefined' && document && document.body) {
          document.body.classList.add('low-end-device');
        }
      } catch (e) {
        // ignore in environments without DOM
      }
    }



    this.getCustomerCount();

    // Start with not-ready; we'll mark ready after data + config are set
    this.isReady = false;

  }

  public productsByCategory() {

    if (this.other == 'category') {
      this.categoryId = this.commonService.getEncryptedId(parseInt(this.id))
      this.productService.productsByCategoryIdx(decodeURIComponent(this.categoryId), this.page, this.size, this.sortOrder).subscribe(
        res => {
          if (res != null) {
              this.categoryProducts = res['content'];
              this.count = res['totalElements'];
              this.isEmpty = res['empty'];
              this.pageSize = res['totalPages'];
            } else {
              this.categoryProducts = [];
              this.count = 0;
              this.isEmpty = true;
              this.pageSize = 0;
            }
            // Only show arrows once we have slides
            this.showArrows = Array.isArray(this.categoryProducts) && this.categoryProducts.length > 0;
        }

      )
    } else {

      let methodName = "getProductBySearch";
      let search = ''
      if (this.other == 'productScope') {
        methodName = "getProductByCustomProductId";
        search = this.id
      } else {

        let value = 1;
        search = "isInStock:" + '*' + value + '*'
          + "' AND featured:" + '*' + value + '*' + "' "
      }


      this.productService[methodName](search, this.page, this.size, this.sortOrder).subscribe(
        res => {
          this.categoryProducts = res['content'];
          this.count = res['totalElements'];
          this.isEmpty = res['empty'];
          this.pageSize = res['totalPages']
        })
    }
  }


  productsByList() {
    this.categoryProducts = this.products;
    this.showArrows = Array.isArray(this.categoryProducts) && this.categoryProducts.length > 0;
  }





  ngAfterViewInit() {
    this.config = {
      observer: true,
      slidesPerView: this.slidesPerView,
      spaceBetween: this.gapLayout,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        0: {
          slidesPerView: this.mobileShow
        },
        480: {
          slidesPerView: this.mobileShow
        },
        740: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: this.slidesPerView
        },
        1500: {
          slidesPerView: this.slidesPerView
        }
      }
    }
    // Defer heavy work until the carousel is near viewport. Use IntersectionObserver when available.
    try {
      const el = this.carouselRoot && this.carouselRoot.nativeElement;
  if (typeof IntersectionObserver !== 'undefined' && el && (el instanceof Element)) {
        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              this.lazyInitialize();
            }
          });
        }, { root: null, rootMargin: '300px', threshold: 0.01 });
        try {
          this.intersectionObserver.observe(el as Element);
        } catch (observeErr) {
          // observe failed unexpectedly; fallback to timeout init
          setTimeout(() => this.lazyInitialize(), 120);
        }
      } else {
        // fallback: initialize after a short delay to avoid blocking bootstrap
        setTimeout(() => this.lazyInitialize(), 120);
      }
    } catch (e) {
      setTimeout(() => this.lazyInitialize(), 120);
    }
  }

  private lazyInitialize() {
    if (this.hasInitialized) return;
    this.hasInitialized = true;

    // fetch products only when visible
    if (this.type != 'product') {
      this.productsByCategory();
    } else {
      this.productsByList();
    }

    // tune swiper lazy loading to load nearby slides only
    try {
      this.config = Object.assign({}, this.config, {
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: this.preloadCount || 1
        }
      });
    } catch (e) { }

    // Wait until the DOM has attached the carousel slides before marking ready.
    // Use requestAnimationFrame to wait for next paint and verify presence of element nodes.
    const maxWait = 500; // ms
    const start = Date.now();

    const checkDomReady = () => {
      try {
        // Prefer the explicit carousel root if available
        const rootEl = this.carouselRoot && this.carouselRoot.nativeElement ? this.carouselRoot.nativeElement : null;

        // Look for internal slide elements (best-effort); if present and first child is an Element, assume ready.
        let ready = false;
        if (rootEl && rootEl.querySelector) {
          const wrapper = rootEl.querySelector('.swiper-wrapper') || rootEl.querySelector('.owl-carousel') || rootEl.querySelector('.carousel');
          if (wrapper && wrapper.children && wrapper.children.length > 0) {
            const firstChild = wrapper.children[0];
            if (firstChild && firstChild.nodeType === 1) {
              ready = true;
            }
          }
        }

        if (ready || (Date.now() - start) > maxWait) {
          this.isReady = true;
          try { this.cd.markForCheck(); } catch (e) { }
          return;
        }
      } catch (ex) {
        // ignore and proceed to next frame
      }

      // schedule next check
      if (typeof window !== 'undefined' && (window as any).requestAnimationFrame) {
        (window as any).requestAnimationFrame(checkDomReady);
      } else {
        // fallback to small timeout
        setTimeout(checkDomReady, 50);
      }
    };

    checkDomReady();
  }

  // trackBy for product *ngFor
  trackByProduct(index: number, item: any) {
    // Prefer stable unique id if available
    return item && (item.entityId || item.id || item.sku) ? (item.entityId || item.id || item.sku) : index;
  }


  goToCategory() {
    if (this.other == 'productScope') {
      this.commonService.productSearch(this.id)
    } else {
      this.commonService.goToCategory(1, parseInt(this.id));
    }
  }
  values: any = "*values*";
  getCustomerCount() {

    let authourized = this.userService.getAuthenticatedUser();
    if (authourized) {


      this.cartServices.geWishListProduct();

      this.cartServices.getCustomerCartProductCount().subscribe(
        (response) => {


          this.values = response;

          let value = localStorage.getItem(Constant.CART_COUNT);
          if (value == null) {
            let encryptedValue = btoa(JSON.stringify(response));

            this.userService.storeProductCartCount(encryptedValue);
          }
        },
        (err) => { }
      );
    }
  }


  totalHoursFromAdmin: any; // Set this value from admin input
  private countdownTarget!: Date;
  private timer!: any;

  days = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;


  startCountdown() {
    this.timer = setInterval(() => {
      const now = new Date().getTime();


      const distance = this.countdownTarget.getTime() - now;

      if (distance <= 0) {
        this.days = this.hours = this.minutes = this.seconds = 0;
        this.isDealOver = true;
        clearInterval(this.timer);
        this.showTimer = false;

        // 💾 Mark as finished
        localStorage.setItem('countdownFinished', 'true');
        localStorage.removeItem('countdownTarget');
        return;
      }

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

    }, 1000);
  }


  ngOnDestroy() {
    clearInterval(this.timer);
    try {
      if (this.intersectionObserver && this.carouselRoot && this.carouselRoot.nativeElement) {
        this.intersectionObserver.unobserve(this.carouselRoot.nativeElement);
      }
    } catch (e) { }
  }

  // Heuristic to detect low-end devices. Keep this conservative and fast.
  isAutoDetectLowEnd(): boolean {
    try {
      if (typeof navigator === 'undefined') return false;
      // Prefer explicit hints where available
      const ua = (navigator && navigator.userAgent) ? navigator.userAgent.toLowerCase() : '';

      // Quick checks
      // - Very low hardware concurrency (1 or 2 logical cores)
      // - Low deviceMemory (<= 2GB) where supported
      const hc = (navigator as any).hardwareConcurrency || 4;
      const dm = (navigator as any).deviceMemory || 4;

      if (hc <= 2 || dm <= 2) return true;

      // Older Android WebViews / phones often contain 'android' and not 'chrome'
      if (ua.includes('android') && (ua.includes('mobile') || !ua.includes('chrome'))) return true;

      return false;
    } catch (e) {
      return false;
    }
  }


}
